import HttpService from "./http.service";

class PermissionService {
  list = async (sortStr = null, filterStr = null) => {
    const permissionsEndpoint = `/permissions?limit=-1${
      sortStr ? sortStr : ""
    }${filterStr ? filterStr : ""}`;
    return await HttpService.get(permissionsEndpoint);
  };

  paginate = async (page = 0, limit = 25, sortStr = null, filterStr = null) => {
    const permissionsEndpoint = `/permissions?page=${page}&limit=${limit}${
      sortStr ? sortStr : ""
    }${filterStr ? filterStr : ""}`;
    return await HttpService.get(permissionsEndpoint);
  };

  listMy = async () => {
    const permissionsEndpoint = "/permissions/my";
    return await HttpService.get(permissionsEndpoint);
  };

  get = async (id) => {
    const permissionsEndpoint = "/permissions";
    return await HttpService.get(`${permissionsEndpoint}/${id}`);
  };

  getByRole = async (role) => {
    const permissionsEndpoint = "/permissions";
    return await HttpService.get(`${permissionsEndpoint}/role/${role}`);
  };

  create = async (data) => {
    const permissionsEndpoint = "/permissions";
    return await HttpService.post(permissionsEndpoint, data);
  };

  update = async (id, data) => {
    const permissionsEndpoint = "/permissions";
    return await HttpService.put(`${permissionsEndpoint}/${id}`, data);
  };

  updateByRole = async (role, data) => {
    const permissionsEndpoint = "/permissions";
    return await HttpService.put(`${permissionsEndpoint}/role/${role}`, data);
  };

  delete = async (id) => {
    const permissionsEndpoint = "/permissions";
    return await HttpService.delete(`${permissionsEndpoint}/${id}`);
  };
}

export default new PermissionService();
